import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import imageUrl from "@/utils/api/imageUrl";
import { GET_APPLICANT_BY_ID } from "@/GraphQL/Queries";
import { useQuery } from "@apollo/client";
import { degree } from "@/utils/helpers";

const ApplicantDetailsModal = ({ isOpen, toggle, applicant }) => {
  if (!applicant) return null;
  const { data, loading, error } = useQuery(GET_APPLICANT_BY_ID, {
    variables: { id: applicant.id },
    fetchPolicy: "network-only",
  });

  const applicantData = data?.getApplicationById?.data;
  const defaultImg =
    "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png";

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>🎓 Applicant Details</ModalHeader>
      <ModalBody>
        <div className="row">
          {/* Profile Image */}
          <div className="col-md-4 text-center mb-3">
            <img
              src={`${imageUrl}/profile/${
                applicantData?.profile_image || "default.png"
              }`}
              alt="Profile"
              style={{
                width: "130px",
                height: "130px",
                borderRadius: "50%",
                objectFit: "cover",
                border: "2px solid #ccc",
                padding: "3px",
              }}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = defaultImg;
              }}
            />
            <p className="mt-2 text-muted small">Profile Image</p>
          </div>

          {/* Basic Info */}
          <div className="col-md-8">
            {/* <div className="mb-2">
              <strong>ID:</strong> {applicant.id}
            </div> */}
            <div className="mb-2">
              <strong>Name:</strong> {applicantData?.name}
            </div>
            <div className="mb-2">
              <strong>Email:</strong> {applicantData?.email}
            </div>
            <div className="mb-2">
              <strong>Mobile:</strong> {applicantData?.mobile}
            </div>
            <div className="mb-2">
              <strong>Present Address:</strong> {applicantData?.address}
            </div>
            <div className="mb-2">
              <strong>Permanent Address:</strong>{" "}
              {applicantData?.permanent_address}
            </div>
            <div className="mb-2">
              <strong>University:</strong> {applicantData?.university}
            </div>
            <div className="mb-2">
              <strong>Department:</strong> {applicantData?.department}
            </div>
            <div className="mb-2">
              <strong>Degree:</strong>
              {degree.find((d) => d.value === applicantData?.degree)?.label ||
                "N/A"}
            </div>
            <div className="mb-2">
              <strong>CGPA:</strong> {applicantData?.cgpa}
              {applicantData?.total_cgpa && ` / ${applicantData?.total_cgpa}`}
            </div>
            <div className="mb-2">
              <strong>Total Professional Experience:</strong>{" "}
              {applicantData?.experience !== undefined
                ? `${applicantData?.experience} years`
                : "N/A"}
            </div>

            {applicantData?.cv && (
              <div className="mb-2">
                <strong>CV:</strong>{" "}
                <a
                  href={`${imageUrl}/cv/${applicantData?.cv}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View CV
                </a>
              </div>
            )}
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-3">
          {applicantData?.extra_curricular && (
            <div className="mb-3">
              <strong>Extracurricular Activities:</strong>
              <div
                dangerouslySetInnerHTML={{
                  __html: applicantData?.extra_curricular,
                }}
              />
            </div>
          )}
          <div className="mb-2">
            <strong>Extracurricular Activities Experience:</strong>{" "}
            {applicantData?.ec_experience !== undefined
              ? `${applicantData?.ec_experience} years`
              : "N/A"}
          </div>

          {applicantData?.achievements && (
            <div className="mb-3">
              <strong>Achievements:</strong>
              <div
                dangerouslySetInnerHTML={{
                  __html: applicantData?.achievements,
                }}
              />
            </div>
          )}

          {applicantData?.writing_samples && (
            <div className="mb-3">
              <strong>Writing Samples / Portfolio:</strong>
              <div>{applicantData?.writing_samples}</div>
            </div>
          )}

          {applicantData?.short_statement && (
            <div className="mb-3">
              <strong>Personal Statement:</strong>
              <div
                dangerouslySetInnerHTML={{
                  __html: applicantData?.short_statement,
                }}
              />
            </div>
          )}
        </div>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ApplicantDetailsModal;
